<template>
    <div class="home">
        <v-container fill-height class="pt-0">
            <h2 class="mb-3">Time Between Failures</h2>
            <report-filter :report-filter-override="reportFilterOverride" v-bind:key="reportFilterComponent"  ref="reportFilter"></report-filter>

            <v-row v-for="row in reportLayouts" :key="row.id">
                <v-col cols="12" :key="chart.chartId" v-for="chart in row.cols" :md="chart.colSpan" xs="12" sm="12">
                    <chart-view :chart-id="chart.chartId"
                                :chart-type="chart.chartType"
                                :report-filter-override="reportFilterOverride"
                                @on-severity-select="onSeveritySelect"
                                :report-layout-id="chart.reportLayoutId"
                                @replaced="onReplaced"></chart-view>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    import ChartView from "../../components/charts/ChartView"
    import ReportFilter from "../../components/reports/ReportFilter"
    import ReportLayoutService from "../../services/reportLayoutService"
    import moment from 'moment';

    export default {
        name: 'TimeBetweenFailures',
        data: function () {
            return {
                accessToken: null,
                reportLayouts: [],
                reportFilterOverride: {
                    startDate: moment().subtract(30, "days").format(moment.HTML5_FMT.DATE),
                    startTime: "00:00",
                    endDate: moment().format(moment.HTML5_FMT.DATE),
                    endTime: "23:59",
                    selectedOperatorBrands: [],
                    selectedIncidentTypes: [],
                    selectedSites: [],
                    startDateAndTime: null,
                    endDateAndTIme: null,
                    selectedResponsibleTeams: [],
                }
            }
        },
        components: {
            ReportFilter,
            ChartView
        },
        methods: {
            async setup() {
                this.accessToken = this.$auth.getAccessToken();
                await this.getReportLayout("TimeBetweenFailures");
            },
            async getReportLayout(name) {
                let results = await ReportLayoutService.getReportLayoutsByName(name, false, this.accessToken);

                let reportRows = [];

                results.forEach(function (item) {

                    if (!reportRows[item.row - 1]) {
                        reportRows.push({
                            cols: [
                                {
                                    chartId: item.chartId,
                                    chartType: item.chartType,
                                    reportLayoutId: item.id,
                                    colSpan: item.colSpan
                                }
                            ]
                        });
                    }
                    else {
                        reportRows[item.row - 1].cols.push({
                            chartId: item.chartId,
                            chartType: item.chartType,
                            reportLayoutId: item.id,
                            colSpan: item.colSpan
                        });
                    }

                });

                this.reportLayouts = reportRows;
            },
            getCols(cols) {
                return Math.floor(12 / cols);
            },
            onChartSelectorClose() {
                this.isChartSelectorVisible = false;
            },
            onReplaced() {
                this.reportLayouts = [];
                this.getReportLayout("TimeBetweenFailures");
            },
            onOperatorSelect(evt) {
                this.reportFilterOverride.selectedOperatorBrands = [];

                var operatorBrands = this.$refs.reportFilter.getOperatorBrands();

                operatorBrands.forEach(brand => {
                    if (brand.toLowerCase() === evt.toLowerCase()) {
                        this.reportFilterOverride.selectedOperatorBrands.push(brand);
                    }
                });
            },
            onSeveritySelect(evt) {
                this.reportFilterOverride.selectedIncidentTypes = [];
                this.reportFilterOverride.selectedIncidentTypes.push(evt);
            }
        },
        created() {
            this.setup();
        }
    }
</script>
